(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfbella-back-to-top"]) return;
  try {
    
  (function() {
    const button = document.querySelector('[data-scroll-to-top]');
    if (!button) return;

    // This theme scrolls on window/body at narrow widths, but at >=990px
    // html/body get overflow: hidden and .page-wrapper becomes the real
    // scrollable element instead (see assets/base.css). Must check/act on
    // both, since which one is actually scrolling depends on viewport width.
    function getScrollPosition() {
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper && wrapper.scrollTop > 0) {
        return wrapper.scrollTop;
      }
      return window.scrollY;
    }

    function toggleButtonVisibility() {
      if (getScrollPosition() > 300) {
        button.classList.add('is-visible');
      } else {
        button.classList.remove('is-visible');
      }
    }

    button.addEventListener('click', function() {
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) {
        wrapper.scrollTo({ top: 0, behavior: 'smooth' });
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', toggleButtonVisibility, { passive: true });
    document.querySelector('.page-wrapper')?.addEventListener('scroll', toggleButtonVisibility, { passive: true });
    toggleButtonVisibility();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfbella-featured-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const buyNowButton = event.target instanceof Element
      ? event.target.closest('[data-bfbella-buy-now]')
      : null;
    if (buyNowButton) {
      window.__bfbellaBuyNowArmed = true;
    }
  });

  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, (cartEvent) => {
      if (window.__bfbellaBuyNowArmed && cartEvent.action === 'add') {
        window.__bfbellaBuyNowArmed = false;
        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfbella-product-information"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumb = event.target instanceof Element ? event.target.closest('[data-bfbella-thumbnail]') : null;
    if (thumb) {
      event.preventDefault();
      const gallery = thumb.closest('.bfbella-pdp__gallery');
      const mainImage = gallery?.querySelector('[data-bfbella-main-image] img');
      const fullSrc = thumb.getAttribute('data-full-src');
      if (mainImage && fullSrc) {
        // Clear srcset/sizes first — a browser ignores a plain .src change
        // when a srcset attribute (built for the previous image) is still present.
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = fullSrc;
      }
      gallery?.querySelectorAll('[data-bfbella-thumbnail]').forEach((el) => {
        el.classList.remove('bfbella-pdp__thumbnail--active');
      });
      thumb.classList.add('bfbella-pdp__thumbnail--active');
    }
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.matches('[data-bfbella-purchase-radio]')) {
      const wrapper = target.closest('.bfbella-pdp__purchase-options');
      const frequency = wrapper?.querySelector('[data-bfbella-frequency]');
      const sellingPlanInput = wrapper?.querySelector('[data-bfbella-selling-plan-input]');
      const select = wrapper?.querySelector('[data-bfbella-frequency-select]');
      const isSubscribe = target.value === 'subscribe';
      if (frequency) frequency.hidden = !isSubscribe;
      if (sellingPlanInput) {
        sellingPlanInput.value = isSubscribe ? select?.value || '' : '';
      }
    }

    if (target.matches('[data-bfbella-frequency-select]')) {
      const wrapper = target.closest('.bfbella-pdp__purchase-options');
      const sellingPlanInput = wrapper?.querySelector('[data-bfbella-selling-plan-input]');
      if (sellingPlanInput) sellingPlanInput.value = target.value;
    }
  });

  document.addEventListener('click', (event) => {
    const navButton = event.target instanceof Element
      ? event.target.closest('[data-bfbella-thumbnail-prev], [data-bfbella-thumbnail-next]')
      : null;
    if (!navButton) return;
    const row = navButton.closest('.bfbella-pdp__thumbnails-row');
    const track = row?.querySelector('[data-bfbella-thumbnails-track]');
    if (!track) return;
    const amount = track.clientWidth * 0.8;
    track.scrollBy({
      left: navButton.hasAttribute('data-bfbella-thumbnail-next') ? amount : -amount,
      behavior: 'smooth',
    });
  });

  function bfbellaUpdateThumbnailNav(row) {
    const track = row.querySelector('[data-bfbella-thumbnails-track]');
    if (!track) return;
    const hasOverflow = track.scrollWidth > track.clientWidth + 1;
    row.classList.toggle('bfbella-pdp__thumbnails-row--has-overflow', hasOverflow);
  }

  document.querySelectorAll('.bfbella-pdp__thumbnails-row').forEach((row) => {
    bfbellaUpdateThumbnailNav(row);
    window.addEventListener('resize', () => bfbellaUpdateThumbnailNav(row));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfbella-shop-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfbella-video-showcase"] && !Shopify.designMode) return;
  try {
    
  class BfbellaVideoShowcase extends HTMLElement {
    connectedCallback() {
      this.featuredFrame = this.querySelector('[data-bfbella-featured-frame]');
      this.featuredEmpty = this.querySelector('[data-bfbella-featured-empty]');
      this.featuredTitle = this.querySelector('[data-bfbella-featured-title]');
      this.featuredPlatform = this.querySelector('[data-bfbella-featured-platform]');
      this.thumbGrid = this.querySelector('[data-bfbella-thumb-grid]');
      this.thumbs = Array.from(this.querySelectorAll('[data-bfbella-thumb]'));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.selectVideo(thumb));
      });

      // Featured player is never server-rendered (see file header comment) — populate it from
      // the first thumbnail immediately so manual mode works with zero network calls. Playlist
      // mode (below) replaces this once its fetch resolves.
      if (this.thumbs.length > 0) {
        this.selectVideo(this.thumbs[0]);
      }

      // Deep link (task 0037): a URL ending in #video-<YouTube id> or #video-<position, 1-based>
      // selects that video and scrolls the player into view, e.g. /#video-rEuZEiuCOIk or /#video-4.
      this.selectFromHash();
      window.addEventListener('hashchange', () => this.selectFromHash());

      const playlistId = this.dataset.playlistId;
      const apiKey = this.dataset.apiKey;
      if (playlistId && apiKey) {
        const maxVideos = parseInt(this.dataset.maxVideos, 10) || 6;
        this.loadPlaylist(playlistId, apiKey, maxVideos);
      }
    }

    selectFromHash() {
      const match = window.location.hash.match(/^#video-([\w-]+)$/);
      if (!match) return;

      const key = match[1];
      const thumb = /^\d{1,2}$/.test(key)
        ? this.thumbs[Number(key) - 1]
        : this.thumbs.find((t) => t.dataset.youtubeId === key);
      if (!thumb) return;

      this.selectVideo(thumb);
      requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
    }

    selectVideo(thumb) {
      const id = thumb.dataset.youtubeId;
      if (!id) return;

      if (this.featuredFrame) {
        this.featuredFrame.src = 'https://www.youtube-nocookie.com/embed/' + id;
      } else if (this.featuredEmpty) {
        const frame = document.createElement('iframe');
        frame.setAttribute('data-bfbella-featured-frame', '');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + id;
        frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        frame.allowFullscreen = true;
        this.featuredEmpty.replaceWith(frame);
        this.featuredFrame = frame;
        this.featuredEmpty = null;
      }

      if (this.featuredTitle) this.featuredTitle.textContent = thumb.dataset.title || '';
      if (this.featuredPlatform) this.featuredPlatform.textContent = thumb.dataset.platform || 'YouTube';

      this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
    }

    async loadPlaylist(playlistId, apiKey, maxVideos) {
      try {
        const url = 'https://www.googleapis.com/youtube/v3/playlistItems'
          + '?part=snippet&playlistId=' + encodeURIComponent(playlistId)
          + '&maxResults=' + Math.min(maxVideos, 50)
          + '&key=' + encodeURIComponent(apiKey);

        const response = await fetch(url);
        if (!response.ok) throw new Error('YouTube API request failed: ' + response.status);

        const data = await response.json();
        const items = (data.items || [])
          .filter((item) => item.snippet && item.snippet.resourceId && item.snippet.resourceId.videoId)
          .sort((a, b) => new Date(b.snippet.publishedAt) - new Date(a.snippet.publishedAt));

        if (items.length === 0) return;

        this.renderPlaylist(items);
      } catch (error) {
        // Playlist fetch failed (bad key, quota, network) — the server-rendered
        // manual blocks (if any) stay exactly as they were. No broken/empty state.
        console.error('BFBella video showcase: could not load YouTube playlist.', error);
      }
    }

    renderPlaylist(items) {
      if (!this.thumbGrid) return;

      this.thumbGrid.innerHTML = '';
      const newThumbs = [];

      items.forEach((item) => {
        const videoId = item.snippet.resourceId.videoId;
        const title = item.snippet.title || '';
        const thumbnails = item.snippet.thumbnails || {};
        const thumbUrl = (thumbnails.medium || thumbnails.default || {}).url
          || ('https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg');

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bfbella-video-showcase__thumb';
        button.setAttribute('data-bfbella-thumb', '');
        button.dataset.youtubeId = videoId;
        button.dataset.title = title;
        button.dataset.platform = 'YouTube';

        const img = document.createElement('img');
        img.src = thumbUrl;
        img.alt = title;
        img.loading = 'lazy';
        img.className = 'bfbella-video-showcase__thumb-img';

        const play = document.createElement('span');
        play.className = 'bfbella-video-showcase__thumb-play';
        play.setAttribute('aria-hidden', 'true');

        const caption = document.createElement('span');
        caption.className = 'bfbella-video-showcase__thumb-caption';
        caption.innerHTML = '<span class="bfbella-video-showcase__thumb-title"></span>'
          + '<span class="bfbella-video-showcase__thumb-platform">YouTube</span>';
        caption.querySelector('.bfbella-video-showcase__thumb-title').textContent = title;

        button.append(img, play, caption);
        button.addEventListener('click', () => this.selectVideo(button));

        this.thumbGrid.appendChild(button);
        newThumbs.push(button);
      });

      this.thumbs = newThumbs;
      this.selectVideo(newThumbs[0]);
    }
  }

  customElements.define('bfbella-video-showcase', BfbellaVideoShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
